import { Hand, Zap } from "lucide-react";

// Iter490 — Auto / Manual switch per court. Manual courts skip auto-scheduling (drag & drop only).
export function CourtModeToggle({ court, canToggle, onToggle }) {
  const manual = !!court.manual_mode;
  return (
    <div className="flex items-center justify-between gap-1 mb-1" data-testid={`court-mode-${court.id}`}>
      {manual ? (
        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[9px] uppercase tracking-widest font-bold bg-[#66C2FF] text-black" data-testid={`court-manual-badge-${court.id}`}>
          <Hand className="w-3 h-3" /> Manual · drag &amp; drop only
        </span>
      ) : (
        <span className="inline-flex items-center gap-1 text-[9px] uppercase tracking-widest text-[#8A8A8A]">
          <Zap className="w-3 h-3" /> Auto
        </span>
      )}
      {canToggle && (
        <button type="button" onClick={() => onToggle(!manual)} data-testid={`court-mode-toggle-${court.id}`}
          title={manual ? "Return this court to auto-scheduling" : "Exclude this court from auto-scheduling — drag & drop only"}
          className="text-[9px] uppercase tracking-widest px-1.5 py-0.5 border border-[#525252] text-[#A3A3A3] hover:border-[#66C2FF] hover:text-[#66C2FF] transition-colors">
          {manual ? "Switch to auto" : "Set manual"}
        </button>
      )}
    </div>
  );
}
